var _title, _desc, _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgDotPurple = function SvgDotPurple(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "09 - Illustration")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main\\uD83D\\uDD25\\uD83D\\uDD25\\uD83D\\uDD25",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01---Home-(V.2)",
    transform: "translate(-1000.000000, -4381.000000)",
    fill: "#5257FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bloc_3",
    transform: "translate(0.000000, 1650.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blocs",
    transform: "translate(120.000000, 291.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09---Illustration",
    transform: "translate(880.000000, 2440.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dots_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 1,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 1,
    cy: 9.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 1,
    cy: 18.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 1,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 1,
    cy: 35.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 1,
    cy: 44.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 1,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 1,
    cy: 61.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 1,
    cy: 70.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 1,
    cy: 79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 9.66666667,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 9.66666667,
    cy: 9.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 9.66666667,
    cy: 18.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 9.66666667,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 9.66666667,
    cy: 35.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 9.66666667,
    cy: 44.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 9.66666667,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 9.66666667,
    cy: 61.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 9.66666667,
    cy: 70.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 9.66666667,
    cy: 79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 18.3333333,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 18.3333333,
    cy: 9.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 18.3333333,
    cy: 18.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 18.3333333,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 18.3333333,
    cy: 35.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 18.3333333,
    cy: 44.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 18.3333333,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 18.3333333,
    cy: 61.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 18.3333333,
    cy: 70.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 18.3333333,
    cy: 79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 27,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 27,
    cy: 9.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 27,
    cy: 18.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 27,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 27,
    cy: 35.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 27,
    cy: 44.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 27,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 27,
    cy: 61.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 27,
    cy: 70.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 27,
    cy: 79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 35.6666667,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 35.6666667,
    cy: 9.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 35.6666667,
    cy: 18.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 35.6666667,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 35.6666667,
    cy: 35.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 35.6666667,
    cy: 44.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 35.6666667,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 35.6666667,
    cy: 61.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 35.6666667,
    cy: 70.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 35.6666667,
    cy: 79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 44.3333333,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 44.3333333,
    cy: 9.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 44.3333333,
    cy: 18.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 44.3333333,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 44.3333333,
    cy: 35.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 44.3333333,
    cy: 44.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 44.3333333,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 44.3333333,
    cy: 61.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 44.3333333,
    cy: 70.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 44.3333333,
    cy: 79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 53,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 53,
    cy: 9.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 53,
    cy: 18.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 53,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 53,
    cy: 35.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 53,
    cy: 44.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 53,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 53,
    cy: 61.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 53,
    cy: 70.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 53,
    cy: 79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 61.6666667,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 61.6666667,
    cy: 9.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 61.6666667,
    cy: 18.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 61.6666667,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 61.6666667,
    cy: 35.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 61.6666667,
    cy: 44.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 61.6666667,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 61.6666667,
    cy: 61.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 61.6666667,
    cy: 70.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 61.6666667,
    cy: 79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 70.3333333,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 70.3333333,
    cy: 9.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 70.3333333,
    cy: 18.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 70.3333333,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 70.3333333,
    cy: 35.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 70.3333333,
    cy: 44.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 70.3333333,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 70.3333333,
    cy: 61.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 70.3333333,
    cy: 70.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 70.3333333,
    cy: 79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 79,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 79,
    cy: 9.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 79,
    cy: 18.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 79,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 79,
    cy: 35.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 79,
    cy: 44.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 79,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 79,
    cy: 61.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 79,
    cy: 70.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 79,
    cy: 79,
    r: 1
  })))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDotPurple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dot-purple.f586fb96.svg";
export { ForwardRef as ReactComponent };